//#region Styles
import { 
    Container, 
    Content, 
    Footer } from "../styles";
import { Image } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
//#endregion
//#region Images
import robotErrorImg from "../img/robot_img.svg";
import NoInternetConnectionIcon from "icons/NoInternetConnectionIcon";
//#endregion

const DialogAlertErrorNotify = ({
    show, toggleShow, 
    closeDialog,
    type = 1, children,
    content, message
}) => {
    const views = [
        <Content>
            <Image src={robotErrorImg} alt="Imagen de error inesperado UTP"/>
            <h3>Ocurrió un error inesperado</h3>
            <p title={message}>
                {message || "Por favor, vuelve a intentarlo en unos momentos."}
            </p>
        </Content>,
        <Content>
            <NoInternetConnectionIcon/>
            <h3>Sin conexión a internet</h3>
            <p>
                Te pedimos revisar tu conexión y volver a intentarlo
            </p>
        </Content>
    ];
    return (
        <DialogAlert
            show={show}
            toggleShow={toggleShow} close={closeDialog}>
            <Container>
                {content 
                ? <Content 
                    widthParagraph={content?.widthParagraph}
                    paddingTop={content?.paddingTop}>
                    {content.image}
                    <h3 className="secondary">{content.title}</h3>
                    <p>{content.value}</p>
                </Content>
                : views[type - 1] || views[0]}
                <Footer>
                    {children 
                    ? children
                    : <CustomButton
                        variant="quaternary"
                        text="Volver a intentarlo"
                        onClick={() => toggleShow(false)}/>}
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertErrorNotify;